import { Boolean, Literal, Null, Number, Optional, Record, Static, String, Unknown } from 'runtypes';

export const UnfinishedElementCountRunType = Record({
	count: Number,
	module: String,
});

export type UnfinishedElementCount = Static<typeof UnfinishedElementCountRunType>;

export type MainMenuItem = {
	allSupported: boolean;
	boxLabel: string;
	boxes: never[];
	hasSubItems: boolean;
	icon: string;
	iconLight: string;
	iconSolid: string;
	label: string;
	lists: never[];
	mineSupported: boolean;
	modernMainMenuItems: ModernMainMenuItem[];
	name:
		| 'addOns'
		| 'agendaList'
		| 'createMenu'
		| 'documentList'
		| 'filterList'
		| 'folderExplorer'
		| 'inbox'
		| 'kanbanBoard'
		| 'logout'
		| 'mailList'
		| 'messageList'
		| 'noteList'
		| 'phoneCallList'
		| 'records'
		| 'settings'
		| 'taskList'
		| 'timer'
		| 'trashList'
		| 'userOnline';
	openSupported: boolean;
	showOnPlatform: 'all' | 'desktop' | 'mobile';
	sortOrder?: number;
	type:
		| 'addOnMenuItem'
		| 'createMenuItem'
		| 'globalFilterMenuItem'
		| 'idoListMenuItem'
		| 'inboxMenuItem'
		| 'specialMenuItem'
		| 'standardMenuItem'
		| 'userOnlineMenuItem';
	unfinishedCount: () => number;
};

export type CreateMainMenuItem = {
	boxLabel: string;
	boxes: never[];
	create: () => void;
	hasSubItems: boolean;
	icon: string;
	iconLight: string;
	iconSolid: string;
	label: string;
	name: string;
};

const ShortcutRunType = Record({
	LinkTarget: String,
	OldSession: Boolean,
	PopUp: Boolean,
	PopUpHeight: Number,
	PopUpWidth: Number,
	ResourceId: Null.Or(String),
	SessionDelimiter: String,
	ShortcutIcon: String,
	Title: String,
});

export const ModernPreDefinedURLSubMenuItemRunType = Record({
	Caption: String,
	ID: Number,
	Method: Literal('GET').Or(Literal('POST')),
	Name: String,
	Parameters: Unknown,
	ParentMainMenuItem: Number.Or(Null),
	ParentMainMenuItemCaption: String.Or(Null),
	RawURL: String,
	ResourceId: String,
	Session: Boolean,
	Type: Literal('IFS\\Menu\\Models\\Domain\\Entities\\SubMenu\\PreDefinedURLSubMenuItem'),
	URL: String,
	URLWithParameters: String,
	checked: Boolean,
});

export type ModernPreDefinedURLSubMenuItem = Static<typeof ModernPreDefinedURLSubMenuItemRunType>;

export const ModernUserDefinedURLSubMenuItemRunType = Record({
	Caption: String,
	ID: Number,
	Method: Literal('GET').Or(Literal('POST')),
	Name: String,
	OpenInBrowserTab: Boolean,
	Parameters: Unknown,
	ParametersAsString: String,
	ParentMainMenuItem: Number.Or(Null),
	ParentMainMenuItemCaption: String.Or(Null),
	RawParameters: Unknown,
	RawParametersAsString: String.Or(Null),
	RawURL: String,
	ResourceId: String,
	Session: Boolean,
	Type: Literal('IFS\\Menu\\Models\\Domain\\Entities\\SubMenu\\UserDefinedURLSubMenuItem'),
	URL: String,
	URLWithParameters: String,
	UserParameter: Boolean,
	checked: Boolean,
});

export type ModernUserDefinedURLSubMenuItem = Static<typeof ModernUserDefinedURLSubMenuItemRunType>;

export const ModernApplicationStarterSubMenuItemRunType = Record({
	Action: String,
	Caption: String,
	ID: Number,
	JSClass: String,
	Name: String,
	ParentMainMenuItem: Number.Or(Null),
	ParentMainMenuItemCaption: String.Or(Null),
	ResourceId: String,
	Type: Literal('IFS\\Menu\\Models\\Domain\\Entities\\SubMenu\\ApplicationStarterSubMenuItem'),
	checked: Boolean,
});

export type ModernApplicationStarterSubMenuItem = Static<typeof ModernApplicationStarterSubMenuItemRunType>;

export const ModernMainMenuItemRunType = Record({
	CSSClass: String,
	Caption: String,
	ID: Number,
	Name: String,
	ResourceId: String,
	SearchTargetURL: Optional(Null.Or(String)),
	Shortcut: Optional(Null.Or(ShortcutRunType)),
	SubMenuItemCount: Number,
	SubMenuItems: Unknown,
	Type: Literal('IFS\\Menu\\Models\\Domain\\Entities\\MainMenu\\PreDefinedMainMenuItem').Or(
		Literal('IFS\\Menu\\Models\\Domain\\Entities\\MainMenu\\UserDefinedMainMenuItem')
	),
	sortOrder: Optional(Number),
	type: Optional(Literal('ModernMainMenuItem')),
});

export type ModernMainMenuItem = Static<typeof ModernMainMenuItemRunType>;
